import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Component } from "preact";
import { PreserveSchedulerComponent } from "../fullcalendar/PreserveSchedulerComponent";
export default class PreserveTimeComponent extends Component {
    constructor(prop) {
        super(prop);
        this.state = {
            start: null,
            end: null
        };
        this.setStartAndEnd = this.setStartAndEnd.bind(this);
    }
    render() {
        return (_jsxs("section", Object.assign({ className: `SchedulePayComponent__container ${this.props.plan ? '' : 'hide'}`, id: "PreserveTimeComponent" }, { children: [_jsxs("h4", Object.assign({ class: "content__title" }, { children: [_jsx("span", { class: "heading" }, void 0), "\u4E88\u7D04\u65E5\u6642"] }), void 0),
                _jsx("label", Object.assign({ class: "label" }, { children: "\u3054\u5E0C\u671B\u306E\u65E5\u6642\u3092\u3010\u9577\u62BC\u3057\u3011\u3067\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044" }), void 0),
                _jsxs("div", Object.assign({ class: "control" }, { children: [this.renderSelectedPeriod(), _jsx(PreserveSchedulerComponent, { planGroup: this.props.planGroup, plan: this.props.plan, callback: this.setStartAndEnd }, void 0)] }), void 0)] }), void 0));
    }
    setStartAndEnd(start, end) {
        this.props.setter(start, end);
        this.setState({
            start: start,
            end: end
        });
    }
    renderSelectedPeriod() {
        const start = this.state.start;
        const end = this.state.end;
        const format = "YYYY/MM/DD HH:mm";
        if (start !== null && end !== null) {
            console.debug('render selected time dom');
            return _jsxs("p", Object.assign({ class: "mb2" }, { children: [_jsxs("span", Object.assign({ class: "selected-time" }, { children: [start.format(format), " ~ ", end.format(format)] }), void 0), "\u304C\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u3059"] }), void 0);
        }
        return _jsx("p", Object.assign({ class: "mb2" }, { children: "\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u305B\u3093" }), void 0);
    }
}
